<template lang="pug">
  #MySa
    .p-3.text-center.mb-5
      h5.font-weight-bold.mt-5 您與顧問解除綁定成功！
    .row.p-3.mx-2
      .col-12
        button.btn.btn-block.btn-primary(
          type="button",
          @click="backToLINEHandler()"
        ) 返回官方帳號

</template>

<script>
export default {
  name: 'unBindSaSuccess',
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
  },
  methods: {
    backToLINEHandler() {
      window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
    }
  }
};
</script>

<style>

</style>
